import { maxHealthStatusCode, } from "@gearbox-protocol/cli-utils";
import { useMemo } from "react";
function isMultichainHealthy(service) {
    return ((service.status === "healthy" ||
        service.status === "warning" ||
        service.status === "alert") &&
        "networks" in service &&
        Array.isArray(service.networks));
}
function expandMultichain(parent) {
    const { networks, ...rest } = parent;
    return networks.map(net => {
        const virtual = {
            ...rest,
            id: `${parent.id}-${net.network}`,
            multichain: true,
            multichainParentId: parent.id,
            family: net.family ?? parent.family,
            network: net.network,
            status: net.status,
            timestamp: net.timestamp,
            dryRun: net.dryRun,
            currentBlock: net.currentBlock,
            marketsConfigurators: net.marketsConfigurators,
            pools: net.pools,
            creditManagers: net.creditManagers,
            providers: net.providers,
        };
        return virtual;
    });
}
export function useDerivedData(input) {
    return useMemo(() => {
        const services = [];
        for (const s of input.services) {
            if (isMultichainHealthy(s)) {
                services.push(...expandMultichain(s));
            }
            else {
                services.push(s);
            }
        }
        const networks = {};
        let others;
        for (const s of services) {
            const net = (s.network ? networks[s.network] : others) ?? {
                status: "healthy",
                services: [],
            };
            net.services.push(s);
            net.status = maxHealthStatusCode(s.status, net.status);
            if (s.network) {
                networks[s.network] = net;
            }
            else {
                others = net;
            }
        }
        return {
            ...input,
            services,
            networks,
            others,
        };
    }, [input]);
}
